<div class="expiring-leases-table-page">
    <!-- Expiring Soon Section -->
    <div class="section">
        <div class="section-header">
            <div class="section-header__title">
                <i class="fa-solid fa-clock"></i>
                <h2>Expiring Soon</h2>
                <span class="count-badge">{{ expiringRows.length }}</span>
            </div>
        </div>

        <div class="table-card" *ngIf="expiringRows.length > 0">
            <table class="data-table">
                <thead>
                    <tr>
                        <th>Days</th>
                        <th>End Date</th>
                        <th>Client</th>
                        <th>Company</th>
                        <th>User</th>
                        <th>Active Sub</th>
                        <th>Future Sub</th>
                        <th>Cancellation Reason</th>
                        <th>Latest Comment</th>
                        <th>Contact</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of expiringRows" class="clickable-row" [class.row-renewed]="row.adminClient.hasFutureSubscription" (click)="openLeadDetail(row)">
                        <td>
                            <span class="urgency-badge" [ngClass]="getUrgencyClass(row.daysUntilExpiry)">
                                {{ row.daysUntilExpiry }}d
                            </span>
                        </td>
                        <td class="date-cell">{{ formatDate(row.summary.endDate) }}</td>
                        <td><span class="client-name">{{ row.adminClient.firstName }} {{ row.adminClient.lastName }}</span></td>
                        <td class="company-cell">{{ row.adminClient.companyName || '-' }}</td>
                        <td>
                            <span *ngIf="row.adminClient.userResponsible" class="user-pill"
                                [style.background-color]="getAssigneeBadgeColor(row.adminClient.userResponsible)">
                                {{ getAssigneeDisplayName(row.adminClient.userResponsible) }}
                            </span>
                            <span *ngIf="!row.adminClient.userResponsible" class="text-muted">-</span>
                        </td>
                        <td class="text-center">
                            <i *ngIf="row.adminClient.hasActiveSubscription" class="fa-solid fa-check-circle text-success"></i>
                            <i *ngIf="!row.adminClient.hasActiveSubscription" class="fa-solid fa-times-circle text-danger"></i>
                        </td>
                        <td class="text-center">
                            <i *ngIf="row.adminClient.hasFutureSubscription" class="fa-solid fa-check-circle text-success"></i>
                            <i *ngIf="!row.adminClient.hasFutureSubscription" class="fa-solid fa-times-circle text-muted"></i>
                        </td>
                        <td class="reason-cell">
                            <span *ngIf="row.summary.nonRenewalReason" class="reason-tag">{{ row.summary.nonRenewalReason }}</span>
                            <span *ngIf="!row.summary.nonRenewalReason" class="text-muted">-</span>
                        </td>
                        <td class="comment-cell">
                            <span *ngIf="getLatestCommentText(row.adminClient)" class="comment-preview">{{ getLatestCommentText(row.adminClient) }}</span>
                            <span *ngIf="!getLatestCommentText(row.adminClient)" class="text-muted">-</span>
                        </td>
                        <td class="contact-cell" (click)="$event.stopPropagation()">
                            <div class="contact-actions">
                                <button *ngIf="row.adminClient.phoneNumber" class="contact-btn contact-btn--call"
                                    (click)="callPhone(row.adminClient.phoneNumber)" title="Call">
                                    <i class="fa-solid fa-phone"></i>
                                </button>
                                <button *ngIf="row.adminClient.phoneNumber" class="contact-btn contact-btn--whatsapp"
                                    (click)="sendWhatsApp(row.adminClient.phoneNumber)" title="WhatsApp">
                                    <i class="fa-brands fa-whatsapp"></i>
                                </button>
                                <button *ngIf="row.adminClient.email" class="contact-btn contact-btn--email"
                                    (click)="sendEmail(row.adminClient.email)" title="Email">
                                    <i class="fa-solid fa-envelope"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="empty-state" *ngIf="expiringRows.length === 0">
            <i class="fa-solid fa-check-circle"></i>
            <p>No subscriptions expiring soon.</p>
        </div>
    </div>

    <!-- Recently Expired Section -->
    <div class="section">
        <div class="section-header">
            <div class="section-header__title">
                <i class="fa-solid fa-hourglass-end"></i>
                <h2>Recently Expired</h2>
                <span class="count-badge">{{ expiredRows.length }}</span>
            </div>
        </div>

        <div class="table-card" *ngIf="expiredRows.length > 0">
            <table class="data-table">
                <thead>
                    <tr>
                        <th>Days</th>
                        <th>End Date</th>
                        <th>Client</th>
                        <th>Company</th>
                        <th>User</th>
                        <th>Active Sub</th>
                        <th>Future Sub</th>
                        <th>Cancellation Reason</th>
                        <th>Latest Comment</th>
                        <th>Contact</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of expiredRows" class="clickable-row" [class.row-renewed]="row.adminClient.hasFutureSubscription" (click)="openLeadDetail(row)">
                        <td>
                            <span class="expired-badge">{{ Math.abs(row.daysUntilExpiry) }}d ago</span>
                        </td>
                        <td class="date-cell">{{ formatDate(row.summary.endDate) }}</td>
                        <td><span class="client-name">{{ row.adminClient.firstName }} {{ row.adminClient.lastName }}</span></td>
                        <td class="company-cell">{{ row.adminClient.companyName || '-' }}</td>
                        <td>
                            <span *ngIf="row.adminClient.userResponsible" class="user-pill"
                                [style.background-color]="getAssigneeBadgeColor(row.adminClient.userResponsible)">
                                {{ getAssigneeDisplayName(row.adminClient.userResponsible) }}
                            </span>
                            <span *ngIf="!row.adminClient.userResponsible" class="text-muted">-</span>
                        </td>
                        <td class="text-center">
                            <i *ngIf="row.adminClient.hasActiveSubscription" class="fa-solid fa-check-circle text-success"></i>
                            <i *ngIf="!row.adminClient.hasActiveSubscription" class="fa-solid fa-times-circle text-danger"></i>
                        </td>
                        <td class="text-center">
                            <i *ngIf="row.adminClient.hasFutureSubscription" class="fa-solid fa-check-circle text-success"></i>
                            <i *ngIf="!row.adminClient.hasFutureSubscription" class="fa-solid fa-times-circle text-muted"></i>
                        </td>
                        <td class="reason-cell">
                            <span *ngIf="row.summary.nonRenewalReason" class="reason-tag">{{ row.summary.nonRenewalReason }}</span>
                            <span *ngIf="!row.summary.nonRenewalReason" class="text-muted">-</span>
                        </td>
                        <td class="comment-cell">
                            <span *ngIf="getLatestCommentText(row.adminClient)" class="comment-preview">{{ getLatestCommentText(row.adminClient) }}</span>
                            <span *ngIf="!getLatestCommentText(row.adminClient)" class="text-muted">-</span>
                        </td>
                        <td class="contact-cell" (click)="$event.stopPropagation()">
                            <div class="contact-actions">
                                <button *ngIf="row.adminClient.phoneNumber" class="contact-btn contact-btn--call"
                                    (click)="callPhone(row.adminClient.phoneNumber)" title="Call">
                                    <i class="fa-solid fa-phone"></i>
                                </button>
                                <button *ngIf="row.adminClient.phoneNumber" class="contact-btn contact-btn--whatsapp"
                                    (click)="sendWhatsApp(row.adminClient.phoneNumber)" title="WhatsApp">
                                    <i class="fa-brands fa-whatsapp"></i>
                                </button>
                                <button *ngIf="row.adminClient.email" class="contact-btn contact-btn--email"
                                    (click)="sendEmail(row.adminClient.email)" title="Email">
                                    <i class="fa-solid fa-envelope"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="empty-state" *ngIf="expiredRows.length === 0">
            <i class="fa-solid fa-inbox"></i>
            <p>No recently expired subscriptions.</p>
        </div>
    </div>
</div>

<!-- Lead Detail Modal -->
<div class="modal-overlay" *ngIf="showLeadDetail && selectedLead" (click)="closeLeadDetail()">
    <div class="modal-card modal-card--full" (click)="$event.stopPropagation()">
        <div class="modal-header modal-header--with-actions">
            <div class="lead-header-row">
                <div class="lead-header-info">
                    <h2>
                        {{ selectedLead.firstName || 'No Name' }} {{ selectedLead.lastName }}
                    </h2>
                    <span class="lead-company" *ngIf="selectedLead.companyName">{{ selectedLead.companyName }}</span>
                </div>
                <div class="header-actions">
                    <button class="action-pill" *ngIf="selectedLead.email" (click)="sendEmail(selectedLead.email)"><i class="fa-solid fa-envelope"></i> Email</button>
                    <button class="action-pill action-pill--call" *ngIf="selectedLead.phoneNumber" (click)="callPhone(selectedLead.phoneNumber)"><i class="fa-solid fa-phone"></i> Call</button>
                    <button class="action-pill action-pill--whatsapp" *ngIf="selectedLead.phoneNumber" (click)="sendWhatsApp(selectedLead.phoneNumber)">
                        <i class="fa-brands fa-whatsapp"></i> WhatsApp
                    </button>
                    <a class="action-pill action-pill--view" [routerLink]="['/client/', selectedLead.$key]" (click)="closeLeadDetail()"><i class="fa-solid fa-external-link"></i> Profile</a>
                </div>
            </div>
            <button class="modal-close" (click)="closeLeadDetail()">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
        <div class="modal-body lead-detail-body">
            <!-- Management Bar -->
            <div class="lead-management-bar">
                <div class="management-field management-field--highlight">
                    <label>Assigned To</label>
                    <select [ngModel]="selectedLead.userResponsible" (ngModelChange)="updateLeadField('userResponsible', $event)">
                        <option value="">Select</option>
                        <option *ngFor="let assignee of crmAssignees" [value]="assignee.$key">{{ assignee.displayName }}</option>
                    </select>
                </div>
                <div class="management-field">
                    <label>Cancellation Reason</label>
                    <select [ngModel]="selectedRow?.summary?.nonRenewalReason" (ngModelChange)="updateNonRenewalReason($event)">
                        <option [ngValue]="null">-- None --</option>
                        <option *ngFor="let reason of nonRenewalReasons" [ngValue]="reason">{{ reason }}</option>
                    </select>
                </div>
                <div class="management-field">
                    <label>Bays</label>
                    <input type="number" [ngModel]="selectedLead.numberOfBays" (ngModelChange)="updateLeadField('numberOfBays', $event)" placeholder="0" />
                </div>
                <div class="management-field">
                    <label>Location</label>
                    <input type="text" [value]="selectedLead.broadLocation || '-'" disabled />
                </div>
            </div>

            <!-- Tabs -->
            <div class="detail-tabs">
                <button class="detail-tab" [class.active]="selectedDetailTab === 'overview'" (click)="selectedDetailTab = 'overview'">
                    <i class="fa-solid fa-user"></i> Overview
                </button>
                <button class="detail-tab" [class.active]="selectedDetailTab === 'subscriptions'" (click)="selectedDetailTab = 'subscriptions'">
                    <i class="fa-solid fa-file-contract"></i> Subscriptions
                    <span class="tab-count" *ngIf="getSubscriptionSummaries().length">{{ getSubscriptionSummaries().length }}</span>
                </button>
                <button class="detail-tab" [class.active]="selectedDetailTab === 'comments'" (click)="selectedDetailTab = 'comments'">
                    <i class="fa-solid fa-comments"></i> Comments
                    <span class="tab-count" *ngIf="selectedLead.commentsCount">{{ selectedLead.commentsCount }}</span>
                </button>
            </div>

            <!-- Overview Tab -->
            <div *ngIf="selectedDetailTab === 'overview'">
                <div class="lead-columns">
                    <div class="lead-column">
                        <div class="lead-section">
                            <h3>Contact Information</h3>
                            <div class="lead-info-grid lead-info-grid--compact">
                                <div class="info-item">
                                    <span class="info-label">Email</span>
                                    <span class="info-value">{{ selectedLead.email || '-' }}</span>
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Phone</span>
                                    <span class="info-value">{{ selectedLead.phoneNumber || '-' }}</span>
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Company</span>
                                    <span class="info-value">{{ selectedLead.companyName || '-' }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="lead-section">
                            <h3>Subscription Status</h3>
                            <div class="status-badges">
                                <div class="status-badge" [class.active]="selectedLead.hasActiveSubscription">
                                    <i class="fa-solid" [class.fa-check]="selectedLead.hasActiveSubscription" [class.fa-xmark]="!selectedLead.hasActiveSubscription"></i>
                                    Active Sub
                                </div>
                                <div class="status-badge" [class.active]="selectedLead.hasFutureSubscription">
                                    <i class="fa-solid" [class.fa-check]="selectedLead.hasFutureSubscription" [class.fa-xmark]="!selectedLead.hasFutureSubscription"></i>
                                    Future Sub
                                </div>
                            </div>
                            <div class="sub-stats">
                                <div class="sub-stat">
                                    <span class="stat-value">{{ selectedLead.completedSubscriptionsCount || 0 }}</span>
                                    <span class="stat-label">Completed</span>
                                </div>
                                <div class="sub-stat sub-stat--warning">
                                    <span class="stat-value">{{ selectedLead.breachedSubscriptionsCount || 0 }}</span>
                                    <span class="stat-label">Breached</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="lead-column">
                        <div class="lead-section">
                            <h3>Campaign Attribution</h3>
                            <div class="lead-info-grid lead-info-grid--compact">
                                <div class="info-item">
                                    <span class="info-label">Source</span>
                                    <span class="info-value">{{ selectedLead.p_source || '-' }}</span>
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Campaign</span>
                                    <span class="info-value">{{ selectedLead.p_campaign || '-' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Subscriptions Tab -->
            <div *ngIf="selectedDetailTab === 'subscriptions'" class="lead-section">
                <div *ngIf="getSubscriptionSummaries().length === 0" class="subscriptions-empty">
                    <i class="fa-solid fa-file-contract"></i>
                    <p>No subscriptions found. Run the subscription sync to populate this data.</p>
                </div>
                <table *ngIf="getSubscriptionSummaries().length > 0" class="subscriptions-table">
                    <thead>
                        <tr>
                            <th>Status</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Period</th>
                            <th>Bays</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let sub of getSubscriptionSummaries()">
                            <td><span class="sub-status-badge" [ngClass]="getStatusClass(sub['status'])">{{ sub['status'] }}</span></td>
                            <td>{{ sub['startDate'] | date: 'mediumDate' }}</td>
                            <td>{{ sub['endDate'] | date: 'mediumDate' }}</td>
                            <td>{{ sub['period'] }} {{ sub['period'] === 1 ? 'month' : 'months' }}</td>
                            <td>{{ sub['baysBooked'] }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Comments Tab -->
            <div *ngIf="selectedDetailTab === 'comments'">
                <div class="lead-section" *ngIf="selectedLead.$key">
                    <app-comments [adminClientKey]="selectedLead.$key!"></app-comments>
                </div>
            </div>
        </div>
    </div>
</div>
